import React from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';

const SEO = ({ title, description, image, url }) => {
    const { t } = useTranslation();

    // Базовое название из переводов (например, "Физика")
    const siteName = t('translate.app_name2');

    // Формируем финальный заголовок
    const fullTitle = title ? `${title} – ${siteName}` : siteName;

    // Базовое описание, если не передано конкретное
    const finalDescription = description || t('translate.app_description');

    // Базовая картинка для превью (положи красивый баннер в папку public)
    const finalImage = image || `${window.location.origin}/og-image.png`;

    return (
        <Helmet>
            {/* Стандартные теги */}
            <title>{fullTitle}</title>
            <meta name="description" content={finalDescription} />

            {/* Open Graph (для Telegram, WhatsApp, VK, Facebook) */}
            <meta property="og:type" content="website" />
            <meta property="og:title" content={fullTitle} />
            <meta property="og:description" content={finalDescription} />
            <meta property="og:image" content={finalImage} />
            {url && <meta property="og:url" content={url} />}

            {/* Twitter Cards (используется многими мессенджерами) */}
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={fullTitle} />
            <meta name="twitter:description" content={finalDescription} />
            <meta name="twitter:image" content={finalImage} />
        </Helmet>
    );
};

export default SEO;